export function getDefaultRouteByRole(roles) {

  if (roles.includes('admin')) {
    return '/orders';
  }

  if (roles.includes('superadmin')) {
    return '/orders';
  }

  if (roles.includes('marketing')) {
    return '/gifts';
  }

  if (roles.includes('reports')) {
    return '/graph-reports';
  }

  if (roles.includes('management')) {
    return '/management-exportorders';
  }

  if (roles.includes('autorreports')) {
    return '/author-reports';
  }

  if (roles.includes('producteditor')) {
    return '/products';
  }

//   if (roles.includes('refunder')) {
//     return '/refunder';
//   }

  if (roles.includes('productreviewer')) {
    return '/reviews';
  }

  if (roles.includes('librarymanager')) {
    return '/librarii/analiza-vanzari';
  }

  if (roles.includes('googleads')) {
    return '/google-reports';
  }

  if (roles.includes('seo')) {
    return '/seo';
  }

  return '/access-denied';
}